import pkg from '../../package.json';
import { BUILD_BRANCH, BUILD_PR, BUILD_SHA } from './build-info.generated';

/** Semver-achtig productversie (package.json) — handmatig bumpen mag. */
export const APP_VERSION = pkg.version;

/** Alleen het versiedeel voor de footer, bv. v1.0.3a */
export const APP_VERSION_DISPLAY = `v${APP_VERSION}`;

/**
 * Korte deploy-ref voor de footer: `PR#370` als bekend, anders `branch@sha`.
 * Wordt gezet door `ops/write-frontend-build-info.sh` (prestart/prebuild + auto-deploy).
 */
export const APP_BUILD_REF = BUILD_PR != null
  ? `PR#${BUILD_PR}`
  : `${BUILD_BRANCH}@${BUILD_SHA}`;

/** Volledige label (compat): v1.0.3a (PR#370) */
export const APP_VERSION_LABEL = `${APP_VERSION_DISPLAY} (${APP_BUILD_REF})`;
